<template>
    <div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    
                    <div class="row mb-2">
                        <div class="col-sm-12 col-md-12 mb-2">
                            <div class="dataTables_filter">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchStock" @keyup.enter="filterSearchStock">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchStock">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2"> 
                            <date-range-picker class="w-100"
                                :minDate="minDate"
                                ref="picker"
                                v-model="dateRange"
                                :opens="'right'"
                                :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                                :autoApply="true"
                                :showDropdowns="true" 
                                :always-show-calendars="true"
                                :single-date-picker="true"
                                :ranges="false"
                                @showCustomRange="showCustomRangeCalendars=true"
                                @update="filterByDate">
                            </date-range-picker>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0" >
                                            <i class="fas fa-store"></i>
                                        </label>
                                        <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0" for="serviceCategory">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect v-model="selectedSubCategory" :options="subCategory" label="text" track-by="id" :searchable="true" :show-labels="false" openDirection="below" @select="filterSubCategory"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in category" :key="c.id">
                                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries !=0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="stockBalanceItems" :sort-compare="sortTable" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(category)="data">
                                            {{getCategoryText(data.item.category, category)}}
                                        </template>
                                        <template #cell(folderID)="data">
                                            {{data.item.folderID ==  '' ? '-' : getCategoryText(data.item.folderID, subCategory)}}
                                        </template>
                                        <template #cell(balance)="data">{{!("total" in data.item) ? 0 : data.item.total}}</template>
                                        <template #cell(basePrice)="data">{{parseFloat(data.item.basePrice).toFixed(2)}}</template>
                                        <template #cell(price)="data">{{parseFloat(data.item.price).toFixed(2)}}</template>
                                        <template #cell(priceInventory)="data">{{!("total" in data.item) ? 0 : parseFloat(getTotal(data.item.total, data.item.price)).toFixed(2)}}</template>
                                        <template #cell(costInventory)="data">{{!("total" in data.item) ? 0 : parseFloat(getTotal(data.item.total, data.item.basePrice)).toFixed(2)}}</template>
                                        <template #cell(action)="data">
                                            <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed mr-2" title="Stock In/Stock Out" @click="editStock(data.item)">
                                                +/-
                                            </button>
                                            <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed" title="View Inventory" @click="getInventory(data.item.itemID, data.item.title)">
                                                <i class="fal fa-inventory"></i>
                                            </button>
                                        </template>
                                        <template #custom-foot>
                                            <b-tr>
                                                <b-td class="border-top-bottom-2 text-right fw-700" colspan="4">{{$t('table.header.subtotal')}}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{stockBalanceSubTotal.price}}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{stockBalanceSubTotal.cost}}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{stockBalanceSubTotal.balance}}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{stockBalanceSubTotal.priceInventory}}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{stockBalanceSubTotal.costInventory}}</b-td>
                                                <b-td class="border-top-bottom-2 disabled-td"></b-td>
                                            </b-tr>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <stockInOut ref="stockInOut" @returnParent="returnStockBalance"></stockInOut>
    </div>
</template>

<script>
import StockInOut from './Stock_In_Out'
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
import {setReturnData, getCategoryText, handleSessionExpired, setCategoryLabel, getSubcategory} from '@/assets/js/dashboard/dashboard.js'
import {convertTimestampToDateTime, convertDateToTimestamp} from '@/assets/js/dashboard/utilities.js'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: 'stockBalance',
    components:{
        StockInOut, DateRangePicker
    },
    data(){
        let startDate = moment();
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            isSpinnerShow: false, 
            stockInOutToggleModal: false, stockTitle: "",
            startDate: '01/01/1990',
            dateRange: {startDate}, dateFilter: "",
            searchStock: "", searchStockFilter: "",
            categoryFilter: "", subCategoryFilter: "",
            outlet: [], selectedOutlet: {},
            category: [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('table.header.category')})}],
            selectedTab: "all",
            subCategories: [], subCategory: [], selectedSubCategory: {},
            stockBalanceItems: [],stockBalanceSubTotal: {},
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", stockExportData: []
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle'},
                { key: "folderID", label: this.$i18n.t('table.header.subcategory'), thClass: 'thead-themed align-middle'},
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "basePrice", label: this.$i18n.t('label.cost'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "balance", label: this.$i18n.t('table.header.balance'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "priceInventory", label: this.$i18n.t('salon_report.stock.price_inventory'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "costInventory", label: this.$i18n.t('salon_report.stock.cost_inventory'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "action", label: "", thClass: 'thead-themed align-middle'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[this.$i18n.t('table.header.title').toUpperCase()] = "name"
            ret[this.$i18n.t('table.header.category').toUpperCase()] = "category"
            ret[this.$i18n.t('table.header.subcategory').toUpperCase()] = "subCategory"
            ret[this.$i18n.t('table.header.balance').toUpperCase()] = "balance"
            ret[this.$i18n.t('label.cost').toUpperCase()] = "cost"
            ret[this.$i18n.t('table.header.price').toUpperCase()] = "price"
            ret[this.$i18n.t('label.total').toUpperCase()] = "total"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setLabel()
            var b = Object.assign({}, this.selectedSubCategory)
            this.selectedSubCategory = this.subCategory.filter(obj=> obj.id == b.id)[0]

            this.setExportData(this.stockExportData)
        }
    },
    methods:{
        getCategoryText(id, category){
            return getCategoryText(id, category);
        },
        getTotal(quantity, price){
            return quantity * price;
        },
        getStockBalanceSubTotal(items){
            var balance = 0; var price = 0; var cost = 0; var priceInventory = 0; var costInventory = 0;
            for(var i=0; i<items.length; i++){
                if('total' in items[i]){
                    balance += items[i].total
                    priceInventory += this.getTotal(items[i].total, items[i].price)
                    costInventory += this.getTotal(items[i].total, items[i].basePrice)
                }
                price += items[i].price
                cost += items[i].basePrice
            }

            return{
                balance: balance,
                price: parseFloat(price).toFixed(2),
                cost: parseFloat(cost).toFixed(2),
                priceInventory: parseFloat(priceInventory).toFixed(2),
                costInventory: parseFloat(costInventory).toFixed(2),
            }
        },
        sortTable(a, b, key){
            if(key == "balance"){
                var aBalance = !("total" in a) ? 0 : a.total
                var bBalance = !("total" in b) ? 0 : b.total
                return aBalance - bBalance
            }else if(key == "costInventory"){
                var aCost = !("total" in a) ? 0 : parseFloat(this.getTotal(a.total,a.basePrice)).toFixed(2)
                var bCost = !("total" in b) ? 0 : parseFloat(this.getTotal(b.total, b.basePrice)).toFixed(2)
                return aCost - bCost
            }else if(key == "priceInventory"){
                var aPrice = !("total" in a) ? 0 : parseFloat(this.getTotal(a.total, a.price)).toFixed(2)
                var bPrice = !("total" in b) ? 0 : parseFloat(this.getTotal(b.total, b.price)).toFixed(2)
                return aPrice - bPrice
            }
            return false
        },
        clearFilter(){
            this.searchStockFilter = this.searchStock = "";
            this.selectedSubCategory = this.subCategory[0];
            this.selectedTab = "all"

            let startDate = moment()
            this.dateRange = {startDate}

            this.dateFilter = "&startDate=" + this.startDate + "&endDate=" + startDate.format(this.$msg.CST.DATE_FORMAT);
            this.setStockBalanceItems(this.dateFilter, "")
        },
        async getStockBalanceItem(strFilter){
            let $vm = this;
            const QUERY_STRING =  "?page=" + $vm.page + strFilter;
            const url =  $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.STOCK_BALANCE + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result= response.data.balance;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result
        },
        async getProductItem(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=product" + strFilter
            const url =  $vm.$api.MENU_ITEM + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.items;  
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        async setStockBalanceItems(stockbalanceFilter, productFilter){
            this.isSpinnerShow = true;
            var stockBalanceItems = await this.getStockBalanceItem(stockbalanceFilter);
            var productItems = await this.getProductItem(productFilter);

            await this.getExportData(stockbalanceFilter, productItems)

            if(stockBalanceItems.length != 0){
                for(var i=0; i<productItems.length; i++){
                    for(var j=0; j<stockBalanceItems.length; j++){
                        if(productItems[i].itemID == stockBalanceItems[j].itemID){
                            productItems[i]["total"] = stockBalanceItems[j].total;
                            break;
                        }
                    }
                }
            }else{
                productItems = stockBalanceItems;
            }
            var retData = setReturnData(productItems, productItems.length, this.page)
            this.stockBalanceItems = retData.result;
            this.totalEntries = retData.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false;

            this.stockBalanceSubTotal = this.getStockBalanceSubTotal(retData.result)
            this.$emit('updateStockBalanceSummaryBox', this.stockBalanceSubTotal)
        },
        editStock(item){
            var obj = {
                folderID: this.selectedSubCategory,
                items: item
            }
            this.$refs.stockInOut.stockInOut(this.selectedOutlet, obj);
        },
        returnStockBalance(subCategory){
            this.stockInOutToggleModal = false;
            this.filterSubCategory(subCategory);
            this.$emit('refreshStockList')
        },
        getInventory(id, title){
            this.$emit('getInventory', id, title, this.selectedOutlet.id)
        },
        filterSearchStock(){
            this.searchStockFilter = this.searchStock == "" ? "" : "&search=" + this.searchStock;
            this.filterStockBalanceItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        filterByOutlet(item){
            this.selectedOutlet = item;
            this.filterStockBalanceItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        filterByDate(date){
            var endDate = moment(date.startDate).format(this.$msg.CST.DATE_FORMAT);

            this.dateFilter = "&startDate=" + this.startDate + "&endDate=" + endDate;
            this.filterStockBalanceItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        async filterCategory(item){
            this.page = 0;
            this.selectedTab = item;
            this.categoryFilter = item == "all"? "" : "&category=" + item;
            this.filterStockBalanceItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);

            this.subCategories = await getSubcategory(this, 'product', this.categoryFilter);
            this.setLabel()
            this.selectedSubCategory = this.subCategory[0]
        }, 
        filterSubCategory(item){
            this.selectedSubCategory = item;
            this.subCategoryFilter = item.id == 0 ? "" : "&folderID=" + item.id;
            this.filterStockBalanceItem(this.dateFilter, this.categoryFilter, this.subCategoryFilter, this.searchStockFilter);
        },
        filterStockBalanceItem(date, category, subCategory, search){
            var strFilter = category + subCategory + search;
            this.setStockBalanceItems(date, strFilter)
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1;
                this.setStockBalanceItems(this.dateFilter, this.categoryFilter + this.subCategoryFilter + this.searchStockFilter)
                //document.getElementById('btnToTop').click(); 
            }
        },
        async getExportData(stockbalanceFilter, productItems){
            let $vm = this
            const url =  $vm.$api.OUTLET + "/" + $vm.selectedOutlet.id + $vm.$api.STOCK_BALANCE + "?" + stockbalanceFilter;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result= response.data.balance;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })

            if(result.length != 0){
                for(var i=0; i<productItems.length; i++){
                    for(var j=0; j<result.length; j++){
                        if(productItems[i].itemID == result[j].itemID){
                            productItems[i]["total"] = result[j].total;
                            break;
                        }
                    }
                }
            }else{
                productItems = result;
            }
            this.stockExportData = productItems
            this.setExportData(productItems)
        },
        setExportData(data){
            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    name: data[i].title,
                    category: getCategoryText(data[i].category, this.category),
                    subCategory: data[i].folderID ==  '' ? '-' : getCategoryText(data[i].folderID, this.subCategory),
                    balance: !("total" in data[i]) ? 0 : data[i].total,
                    cost: !("total" in data[i]) ? 0 : this.getTotal(data[i].total, data[i].basePrice),
                    price: data[i].price,
                    total: !("total" in data[i]) ? 0 : this.getTotal(data[i].total, data[i].price)
                })
            }

            this.exportData = exportData;
            var strDate =  moment(this.dateRange.startDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_stock`) + " (" + this.$i18n.messages[this.$i18n.locale].tab.stockTabs[0].text + ")"
            this.exportHeaders = [
                header, 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (this.selectedOutlet.id == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : this.selectedOutlet.text),
                " "];
            this.exportFileName =  header.split(" ").join("_") + strDate  +  this.$msg.REPORT.CSV
        },
        setLabel(){
            var category = JSON.parse(this.$store.state.category);
            this.category = setCategoryLabel(this, true, this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}), category.product)
            this.subCategory = setCategoryLabel(this, false, this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')}), this.subCategories)
        },
    },
    async mounted(){
        let $vm = this;
        $vm.dateFilter = "&startDate=" + $vm.startDate + "&endDate=" + moment($vm.dateRange.startDate).format(this.$msg.CST.DATE_FORMAT)
        
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        
        $vm.setStockBalanceItems($vm.dateFilter, "")
        
        $vm.subCategories = await getSubcategory($vm, 'product', "");
        $vm.setLabel()
        $vm.selectedSubCategory = $vm.subCategory[0]
    }
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
.show{
    display: block;
}
.modal-lg{
    max-width: 60vw;
}
.modal-body-lg{
    min-height: 60vh;
    max-height: 80vh;
    overflow-y: auto;
}
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
.disabled-td{
    background: #e9e9e9;
}
</style>